/**
 * Prikazuje/sakriva elemente sa searchUnitExterior klasom ovisno o širini prozora na inicijalni poziv i na svaki
 * promjenu orijentacije.
 *
 * @param {Object} document
 * @param {Object} window
 * @param {Boolean} doubleColumnsOnBigScreen - Ako se na širim ekranima elementi slažu u dvije kolumne (npr. kao na
 * rezultatima pretrage)
 */
export function toggleExteriorSizeVisibilityUnconfigured({ document, window, doubleColumnsOnBigScreen = true }) {
    toggleExteriorSize(doubleColumnsOnBigScreen);

    window.addEventListener('orientationchange', () => {
        const resizeEventHandler = () => {
            toggleExteriorSize(doubleColumnsOnBigScreen);
            window.removeEventListener('resize', resizeEventHandler);
        };

        // Ispravnu širinu prozora nakon promjene orjentacije možemo dohvatiti tek nakon što se izvrši resize event
        window.addEventListener('resize', resizeEventHandler);
    });

    function toggleExteriorSize() {
        const winWidth = window.outerWidth;

        if (winWidth < 480 || (doubleColumnsOnBigScreen && winWidth > 800 && winWidth < 1024)) {
            document.querySelectorAll('.searchUnitExterior').forEach((element) => element.classList.add('hidden'));

            return;
        }

        document.querySelectorAll('.searchUnitExterior').forEach((element) => element.classList.remove('hidden'));
    }
}

export default function toggleExteriorSizeVisibility(doubleColumnsOnBigScreen = true) {
    toggleExteriorSizeVisibilityUnconfigured({ document, window, doubleColumnsOnBigScreen });
}
